// Metadados do portal "Rede Federal no Mago".
// Os dados das instituições vêm dos arquivos estáticos gerados por gen_rede_federal.js:
//   /rede-federal/index.json        -> panorama (instituições + indicadores + médias)
//   /rede-federal/inst/<slug>.json   -> detalhe por instituição (indicadores + respostas TCU)

// Indicadores do TCU (chave no CSV -> rótulo curto e descrição).
export const INDICADORES = [
  { id: 'iES', sigla: 'iES', label: 'iES Geral', desc: 'Índice de Governança e Gestão (consolidado)', grupo: 'Geral' },
  { id: 'iESGo', sigla: 'iESGo', label: 'Sustentabilidade e Governança', desc: 'Índice ESG e de Governança', grupo: 'Geral' },
  { id: 'iGG', sigla: 'iGG', label: 'Governança e Gestão Geral', desc: 'Índice integrado de Governança e Gestão', grupo: 'Geral' },
  { id: 'iGovPub', sigla: 'iGovPub', label: 'Governança Pública', desc: 'Governança organizacional pública', grupo: 'Governança' },
  { id: 'iGovSustentAmb', sigla: 'iGovSustentAmb', label: 'Governança Ambiental (E)', desc: 'Sustentabilidade ambiental', grupo: 'Governança' },
  { id: 'iGovSustentSocial', sigla: 'iGovSustentSocial', label: 'Governança Social (S)', desc: 'Sustentabilidade social', grupo: 'Governança' },
  { id: 'iGovPessoas', sigla: 'iGovPessoas', label: 'Governança de Pessoas', desc: 'Governança da gestão de pessoas', grupo: 'Governança' },
  { id: 'iGovTI', sigla: 'iGovTI', label: 'Governança de TI', desc: 'Governança de tecnologia da informação', grupo: 'Governança' },
  { id: 'iGovContratações', sigla: 'iGovContratações', label: 'Governança de Contratações', desc: 'Governança das contratações', grupo: 'Governança' },
  { id: 'iGovOrcament', sigla: 'iGovOrcament', label: 'Governança Orçamentária', desc: 'Governança orçamentária', grupo: 'Governança' },
  { id: 'iGestPessoas', sigla: 'iGestPessoas', label: 'Gestão de Pessoas', desc: 'Gestão de pessoas', grupo: 'Gestão' },
  { id: 'iGestTI', sigla: 'iGestTI', label: 'Gestão de TI', desc: 'Gestão de tecnologia da informação', grupo: 'Gestão' },
  { id: 'iGestContrat', sigla: 'iGestContrat', label: 'Gestão de Contratações', desc: 'Gestão das contratações', grupo: 'Gestão' },
  { id: 'iGestOrcament', sigla: 'iGestOrcament', label: 'Gestão Orçamentária', desc: 'Gestão orçamentária', grupo: 'Gestão' },
];

export const INDICADOR_LABEL = INDICADORES.reduce((acc, i) => { acc[i.id] = i.label; return acc; }, {});

// Faixas de maturidade (mesma escala do diagnóstico público).
export const getFaixaMaturidade = (percentual) => {
  if (percentual >= 70) return { texto: 'Aprimorado', classe: 'aprimorado', cor: '#28a745' };
  if (percentual >= 40) return { texto: 'Intermediário', classe: 'intermediario', cor: '#ffc107' };
  if (percentual >= 15) return { texto: 'Inicial', classe: 'inicial', cor: '#fd7e14' };
  return { texto: 'Inexpressivo', classe: 'inexpressivo', cor: '#dc3545' };
};

// Mapa de respostas do TCU (valor -> texto), igual ao usado no benchmarking.
export const MAPA_RESPOSTA = {
  8: 'Adota em grande parte ou totalmente',
  7: 'Adota em parte',
  6: 'Adota em menor parte',
  5: 'Há decisão formal ou plano aprovado para adotá-lo',
  4: 'Não adota',
};
